var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',{staticStyle:{"height":"100vh"},attrs:{"justify":"center","align":"center"}},[_c('v-progress-circular',{attrs:{"indeterminate":""}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }